import Vue from "vue"
import VueRouter, {Route} from "vue-router"
import Home from "@/views/Home.vue"
import SignUp from "@/views/Auth/SignUp.vue"
import SignUpVerifyCode from "@/views/Auth/SignUpVerifyCode.vue"
import SignIn from "@/views/Auth/SignIn.vue"
import ForgetPassword from "@/views/Auth/ForgetPassword.vue"
import NotificationList from "@/views/NotificationList.vue"
import NotificationCreate from "@/views/NotificationCreate.vue"
import NotificationView from "@/views/NotificationView.vue"
import ReportToken from "@/views/Report/ReportToken.vue"
import ReportNotification from "@/views/Report/ReportNotification.vue"
import ReportCTRTransition from "@/views/Report/ReportCTRTransition.vue"
import ChangePassword from "@/views/Profile/ChangePassword.vue"
import EditProfile from "@/views/Profile/EditProfile.vue"
import AdminUserList from "@/views/Admin/UserList.vue"
import AdminUserEdit from "@/views/Admin/UserEdit.vue"
import AdminSiteList from "@/views/Admin/SiteList.vue"
import AdminSiteCreate from "@/views/Admin/SiteCreate.vue"
import DebugTestPush from "@/views/Debug/TestPush.vue"
import Forbidden from "@/views/Error/Forbidden.vue"
import NotFound from "@/views/Error/NotFound.vue"
import Test from "@/views/Test.vue"
import {vxm} from "@/store"

Vue.use(VueRouter)

const meta = {
  noAuth : {requireAuth: false, requireNoAuth: true},
  isAdmin: {isAdmin: true}
}

const routes = [

  {path: "/", name: "Home", component: Home},
  {path: "/test", name: "Test", component: Test},

  {path: "/signup", name: "SignUp", component: SignUp, meta: meta.noAuth},
  {path: "/signup/verify", name: "SignUpVerifyCode", component: SignUpVerifyCode, meta: meta.noAuth},
  {path: "/signin", name: "SignIn", component: SignIn, meta: meta.noAuth},
  {path: "/forget_password", name: "ForgetPassword", component: ForgetPassword, meta: meta.noAuth},


  {path: "/notifications", name: "NotificationList", component: NotificationList},
  {path: "/notifications/create", name: "NotificationCreate", component: NotificationCreate},
  {path: "/notifications/:id", name: "NotificationView", component: NotificationView},

  {path: "/reports/token", name: "ReportToken", component: ReportToken},
  {path: "/reports/notifications", name: "ReportNotification", component: ReportNotification},
  {path: "/reports/ctr", name: "ReportCTRTransition", component: ReportCTRTransition},

  {path: "/profile/edit_profile", name: "EditProfile", component: EditProfile},
  {path: "/profile/change_password", name: "ChangePassword", component: ChangePassword},

  {path: "/admin/users", name: "AdminUserList", component: AdminUserList, meta: meta.isAdmin},
  {path: "/admin/users/:id/edit", name: "AdminUserEdit", component: AdminUserEdit, meta: meta.isAdmin},
  {path: "/admin/sites", name: "AdminSiteList", component: AdminSiteList, meta: meta.isAdmin},
  {path: "/admin/sites/create", name: "AdminSiteCreate", component: AdminSiteCreate, meta: meta.isAdmin},
  {path: "/admin/sites/:id/edit", name: "AdminSiteEdit", component: AdminSiteCreate, meta: meta.isAdmin},

  {path: "/debug/test_push", name: "DebugTestPush", component: DebugTestPush, meta: meta.isAdmin},

  {path: "/forbidden", name: "Forbidden", component: Forbidden, meta: {noSideBar: true}},
  {path: "/*", name: "NotFound", component: NotFound, meta: {noSideBar: false}}
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

// redirect
router.beforeResolve(async (to: Route, _from: Route, next) => {
  if (to.meta.requireNoAuth === true && vxm.auth.isAuth) {
    next({name: "Home"})
  } else if (to.name === "SignIn" || to.meta.requireAuth === false) {
    next()
  } else {
    if (vxm.auth.isAuth) {

      if (to.meta.isAdmin && !vxm.auth.isAdmin) {
        next({name: "Forbidden"})
      } else {
        next()
      }
    } else {
      next({name: "SignIn"})
    }
  }
})
router.afterEach(async (to, from) => {
  await vxm.ui.hideSideNavi()
})


export default router
